import React from 'react';
import { View, StyleSheet } from 'react-native';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import CalendarIcon from '../../assets/icons/workout-history-header-icons/calendar.svg';
import DurationIcon from '../../assets/icons/workout-history-header-icons/duration.svg';
import WorkoutTypeIcon from '../../assets/icons/workout-history-header-icons/workout-type.svg';
import EffortPointsIcon from '../../assets/icons/workout-history-header-icons/effort-points.svg';
import KiloCalIcon from '../../assets/images/kilo-calories.svg';
import EffortPercentageIcon from '../../assets/icons/workout-history-header-icons/effort-percentage.svg';
import BodyGroupsIcon from '../../assets/icons/workout-history-header-icons/target-body-group.svg';
import SortHeaderCell from './SortHeaderCell';

interface IWorkoutHistoryHeaderProps {
    sortByDate: () => void;
    sortByDuration: () => void;
    sortByActivityType: () => void;
    sortByBodyGroups: () => void;
    sortByLoad: () => void;
    sortByCals: () => void;
    sortByAverageHeartRate: () => void;
    field: string;
    order: 'asc' | 'desc';
}

const WorkoutHistoryHeader: React.FC<IWorkoutHistoryHeaderProps> = ({
    sortByDate,
    sortByDuration,
    sortByActivityType,
    sortByBodyGroups,
    sortByLoad,
    sortByCals,
    sortByAverageHeartRate,
    field,
    order,
}) => {
    return (
        <View style={styles.container}>
            <SortHeaderCell
                onPress={sortByDate}
                IconComponent={CalendarIcon}
                isCurrentSortField={field === 'sortByDate'}
                currentSortOrder={order}
                cellStyle={styles.dateCell}
            />
            <SortHeaderCell
                onPress={sortByDuration}
                IconComponent={DurationIcon}
                isCurrentSortField={field === 'sortByDuration'}
                currentSortOrder={order}
                cellStyle={styles.dateCell}
            />
            <SortHeaderCell
                onPress={sortByActivityType}
                IconComponent={WorkoutTypeIcon}
                isCurrentSortField={field === 'sortByActivityType'}
                currentSortOrder={order}
            />
            <SortHeaderCell
                onPress={sortByLoad}
                IconComponent={EffortPointsIcon}
                isCurrentSortField={field === 'sortByLoad'}
                currentSortOrder={order}
            />
            <SortHeaderCell
                onPress={sortByCals}
                IconComponent={KiloCalIcon}
                isCurrentSortField={field === 'sortByCals'}
                currentSortOrder={order}
            />
            <SortHeaderCell
                onPress={sortByAverageHeartRate}
                IconComponent={EffortPercentageIcon}
                isCurrentSortField={field === 'sortByAverageHeartRate'}
                currentSortOrder={order}
            />
            <SortHeaderCell
                onPress={sortByBodyGroups}
                IconComponent={BodyGroupsIcon}
                isCurrentSortField={field === 'sortByBodyGroups'}
                currentSortOrder={order}
                cellStyle={styles.noBorder}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: Theme.GREY_LIGHT,
        justifyContent: 'space-between',
        marginHorizontal: defaultScale(10),
    },
    dateCell: {
        flex: 1.6,
    },
    noBorder: {
        borderRightWidth: 0,
    },
});

export default translate(['home'], { wait: true })(WorkoutHistoryHeader);
